import {
  useGetApiV1GroupsByGroupIdChannelsQuery,
  useGetApiV1GroupsByGroupIdQuery,
  useGetApiV1GroupsByGroupIdChannelsPublicQuery,
} from '../../api'
import { UserFull } from '@wellesley/openapi'

type UseGroupChannelsOptions = {
  groupId?: string
}

type UseGroupChannelsReturn = {
  channels: UserFull[]
  isLoading: boolean
  isError: boolean
}

export const useGroupChannels = ({
  groupId = '',
}: UseGroupChannelsOptions): UseGroupChannelsReturn => {
  const {
    data: group,
    isLoading: isGroupLoading,
    isError: isGroupError,
  } = useGetApiV1GroupsByGroupIdQuery({ groupId }, { skip: !groupId })

  const isMember = group?.isMember

  const {
    data,
    isLoading: isChannelsLoading,
    isError: isChannelsError,
  } = useGetApiV1GroupsByGroupIdChannelsQuery(
    {
      groupId,
      full: true,
    },
    {
      skip: !groupId || !isMember || !group,
    },
  )

  const {
    data: publicChannels,
    isLoading: isPublicChannelsLoading,
    isError: isPublicChannelsError,
  } = useGetApiV1GroupsByGroupIdChannelsPublicQuery(
    {
      groupId,
    },
    {
      skip: !groupId || !group,
    },
  )

  const isLoading =
    isGroupLoading || isChannelsLoading || isPublicChannelsLoading

  const isError = isGroupError || isChannelsError || isPublicChannelsError
  return {
    channels: (data || publicChannels || []) as UserFull[],
    isLoading,
    isError,
  }
}
